import { Injectable } from '@angular/core';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { AppTextMask } from '../models/interface/app-text-mask';

@Injectable()
export class NumberFormatterService {
  public unMaskPrice(price: any): number {
    if (!price) {
      return 0;
    }
    if (typeof price !== 'string') {
      price = price.toString();
    }
    return parseFloat(price.split('$').join('').split(',').join(''));
  }

  public unMaskPercentage(percentage: any): number {
    if (!percentage) {
      return 0;
    }
    if (typeof percentage !== 'string') {
      percentage = percentage.toString();
    }
    return parseFloat(percentage.split('%').join(''));
  }

  public createPriceMask(): any {
    return createNumberMask({
      prefix: '$ ',
      suffix: '',
      allowDecimal: true,
    });
  }

  public createPricePerHourMask(): any {
    return createNumberMask({
      prefix: '$ ',
      suffix: '/hr',
      allowDecimal: true,
    });
  }

  public createPricePerPersonMask(): any {
    return createNumberMask({
      prefix: '$ ',
      suffix: '/pp',
      allowDecimal: true,
    });
  }

  public unMaskPricePerHour(price: any): number {
    if (!price) {
      return 0;
    }
    if (typeof price !== 'string') {
      price = price.toString();
    }
    return parseFloat(
      price.split('$').join('').split(',').join('').split('/hr').join(''),
    );
  }

  public createPercentageMask(): AppTextMask {
    return createNumberMask({
      prefix: '',
      suffix: ' %',
      allowDecimal: true,
    });
  }

  public formatStringAsCurrency(numberString: string): string {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    return formatter.format(Number.parseFloat(numberString));
  }

  /**
   * deprecated
   * prefer the parseArrayFromJsonString from ArrayParsingUtils
   */
  public parseArrayFromJson(json: string): Array<any> {
    try {
      if (typeof json !== 'string') {
        return json;
      }
      let isString = true;
      let el = JSON.parse(json) as any;
      if (typeof el === 'string') {
        while (isString) {
          el = JSON.parse(el);
          if (typeof el !== 'string') {
            isString = false;
          }
        }
      }
      return el as Array<any>;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  public parseJsonIfString(json): any {
    if (typeof json === 'string') {
      return JSON.parse(json);
    }
    return json;
  }

  public getDateFromDateString(dateString: string): string {
    const { month, day, year } =
      this.getMonthDayAndYearFromDateString(dateString);
    return new Date(year, month, day).toISOString();
  }

  private getMonthDayAndYearFromDateString(dateString: string): any {
    const tempArr = dateString.split('/');
    const month = parseInt(tempArr[0]) - 1;
    const day = parseInt(tempArr[1]);
    const year = parseInt(tempArr[2]);
    return { month, day, year };
  }

  public isDate18orMoreYearsOld(dateString: string) {
    const { month, day, year } =
      this.getMonthDayAndYearFromDateString(dateString);
    const dateIsValid = this.checkIfValidDate(month, day, year);
    if (dateIsValid) {
      return new Date(year + 18, month - 1, day) <= new Date();
    } else {
      return false;
    }
  }

  private checkIfValidDate(month: number, day: number, year: number) {
    if (year.toString().length === 4) {
      return true;
    } else {
      return false;
    }
  }

  public convertCentsToDollars(amountInCents: string | number) {
    try {
      let amountInDollars: number = null;
      if (typeof amountInCents === 'string') {
        amountInCents = parseFloat(amountInCents);
        amountInDollars = amountInCents / 100;
      } else {
        amountInDollars = amountInCents / 100;
      }

      amountInDollars = Number(amountInDollars.toFixed(2));

      return amountInDollars;
    } catch (e) {
      console.log('Error converting amount in cents. Amount:', amountInCents);
      return null;
    }
  }
}
